module.exports = __webpack_public_path__ + "icon_kasvu.787e998e3984f7041b9a.svg";